module.exports = __webpack_public_path__ + "img/Preview-4.0cc25cac.png";